import { blob, download, get, post, remove, upload } from "./api";
import routes from "./end-points";

export const driveApi = {
    objects: (parentId) => get(routes.drive.objects(parentId)),
    delete: (id) => remove(routes.drive.delete(id)),
    deleteMember: (id) => remove(routes.drive.deleteMember(id)),
    saveChanges: (dto) => post(routes.drive.saveChanges, dto),
    downloadLink: (id) => routes.drive.download(id),
    downloadLinkWithDimentions: (id, width, height) => routes.drive.downloadWithDimentions(id, width, height),
    downloadImage: (id, mimeType) => download(routes.drive.download(id), mimeType),
    upload: (files, dto, onUploadProgress) => {
        const form_data = new FormData();
        [...files].forEach((file) => form_data.append("files", file));
        for (const [key, value] of Object.entries(dto)) form_data.append(key, value);
        return upload(routes.drive.upload, form_data, onUploadProgress);
    },
    initAccessUsers: (driveId) => get(routes.drive.initAccessUsers(driveId)),
    saveAccess: (dto) => post(routes.drive.saveAccess, dto),
    makeBlob: (url, mimeType) => blob(url, mimeType),
};
